module.exports = __webpack_public_path__ + "static/media/54_1095.bda467f6.webp";